import { Injectable, inject } from '@angular/core';
import Time from '../utils/timer.service';
import Session from '../utils/session.service';
import Config from '../utils/config.service';
import ChatRestServices from '../services/chat-rest.service';
import ProfileRestServices from '../services/profile-rest.service';
import NotificationService from '../services/notification.service';
import StatusService from '../services/status.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularFilterHelperService from '../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../services/angular-broadcast-helper.service';
import $ from 'jquery';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export default class ChatService {
	private time: Time = inject(Time);
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private profileRestServices: ProfileRestServices = inject(ProfileRestServices);
	private notificationService: NotificationService = inject(NotificationService);
	private statusService: StatusService = inject(StatusService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	documentFocusLostAt: any = undefined;
	initDate: any = new Date();
	lastSeenPost: any = 0;
	lastModifiedAt: any = undefined;
	firstPollCall: any = true;
	unreadMessages: Array<any> = [];
	chats: any = undefined;
	sessionUser: any = undefined;
	pollLastModifiedAt: any = undefined;
	
	constructor() {
		this.lastModifiedAt = this.initDate.getTime();
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.INIT_CHAT,
			(event, data) => {
				this.sessionUser = this.session.getSession();

				this.chatRestServices.getHistory({ 'start': 0, 'end': 25 }, 
					(conversations) => {
						this.updateLastSeenPost(conversations);
						this.chats = this.mapChatFriendName(this.mapConversationsById(conversations));
						this.angularBroadcastHelperService.rootEmit(this.config.getBroadcastConfig().Chat.INIT, this.chats);
						this.initPolling();

						var users: Array<any> = [];
						this.angularHelperService.forEach(this.chats, (chat) => { users.push(chat.privateChatFriend); });
						this.statusService.addUsers(users);
					},
					(error) => {
						console.error('ChatService.GetHistory', error);
					}
				);
			}
		);
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.MESSAGE_SENT, (event, message, chatId) => {
			this.setChatLastMessage(chatId, message);
		});
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.UPDATE_LAST_POST_SEEN, (event, message, chatId) => {
			this.updateLastPostSeen(message, chatId);
		});
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.UPDATE_CHAT_STATUS, (event, chatEvent, chatId) => {
			if (this.chats[chatId]) {
				if (chatEvent.eventType === 'CHATBOT_DISABLED') {
					this.chats[chatId].activeAiSessionId = null;
					this.chats[chatId].aiStatus = null;
				} else if (chatEvent.eventType === 'CHATBOT_ACTIVATED') {
					this.chats[chatId].activeAiSessionId = true;
				} else if (chatEvent.eventType === 'INTERVENTION_NEEDED') {
					this.chats[chatId].activeAiSessionId = null;
					this.chats[chatId].aiStatus = 'INTERVENTION_REQUIRED';
				} else if (chatEvent.eventType === 'CRITICAL_INTERVENTION_NEEDED') {
					this.chats[chatId].activeAiSessionId = null;
					this.chats[chatId].aiStatus = 'CRITICAL_INTERVENTION_REQUIRED';
				} else if (chatEvent.eventType === 'CHAT_ENABLED') {
					this.chats[chatId].disabled = false;
				} else if (chatEvent.eventType === 'CHAT_DISABLED') {
					this.chats[chatId].disabled = true;
				} else if (chatEvent.eventType === 'CHATBOT_SUMMARY') {
					this.chats[chatId].aiStatus = 'SUMMARY_FORWARD_REQUIRED';
				}
			}
		});
	}
	
	updateLastPostSeen(message, chatId) {
		var modified: any = new Date(message.modified);
		var modifiedTime: any = modified.getTime();
		if (modifiedTime > this.lastModifiedAt) this.lastModifiedAt = modifiedTime;
		if (this.unreadMessages && this.unreadMessages[chatId]) delete this.unreadMessages[chatId];
	}
	
	getChats() {
		return this.chats;
	}
	
	initPolling() {
		console.log("Init chat polling.")
		$(window).on('focus.poll', () => { this.documentFocusLostAt = undefined; });
		$(window).on('blur.poll', () => { this.documentFocusLostAt = moment(); });
		
		setTimeout(() => {
			var secondsToPollAfterBlur: any = 1800;
			var user: any = this.sessionUser && this.sessionUser.user || {};
			
			this.time.newTimer('CHAT_POST_POLLING_TIMER', () => {
				var documentFocusLostDiff: any = this.documentFocusLostAt
					? moment.duration(moment().diff(this.documentFocusLostAt)).asSeconds()
					: 0;
				var shouldPoll: any = user.businessUser || document.hasFocus() || documentFocusLostDiff < secondsToPollAfterBlur;
				if (shouldPoll) this.pollNewPosts();
			}, 5000);
		}, 5000);
	}
	
	openChatById(friend, id) {
		if (!id || !this.chats[id]) {
			this.openNewChat(friend, id);
			return;
		}
		if (this.chats[id]) {
			this.angularBroadcastHelperService.rootEmit(this.config.getBroadcastConfig().Chat.OPEN, this.chats[id]);
		}
	}
	
	openNewChat(friend, chatId) {
		var newChat: any = {
			privateChatFriend: friend,
			localId: Date.now()
		};
		if (chatId) {
			newChat.id = chatId;
		}
		this.angularBroadcastHelperService.rootEmit(this.config.getBroadcastConfig().Chat.OPEN, newChat);
	}
	
	initNewChat(chat) {
		this.mapChatFriendName([chat]);
		this.chats[chat.id] = chat;
		this.angularBroadcastHelperService.rootEmit(this.config.getBroadcastConfig().Chat.NEW, chat);
		this.setChatLastMessage(chat.id, chat.lastPost);
		this.updateLastPostSeen(chat.lastPost, chat.id);
		
		this.statusService.addUsers([chat.privateChatFriend]);
	}
	
	getCallingMessage = (message) => {
		switch (message.content) {
			case 'HUNG_UP-NORMAL_CLEARING':
				return this.angularFilterHelperService.translate('Call.Content.Call_Ended');
			case 'HUNG_UP-PROGRESS_TIMEOUT':
				return this.angularFilterHelperService.translate('Call.Content.Call_Ended');
			case 'HUNG_UP-CONNECTION_LOST':
				return this.angularFilterHelperService.translate('Call.Content.Call_Ended');
			case 'HUNG_UP-ORIGINATOR_CANCEL':
				return this.angularFilterHelperService.translate('Call.Content.Call_Not_Answered');
			case 'DECLINED-NORMAL_CLEARING':
				return this.angularFilterHelperService.translate('Call.Content.User_Busy');
			case 'DECLINED-PROGRESS_TIMEOUT':
				return this.angularFilterHelperService.translate('Call.Content.Call_Ended');
			case 'NO_ANSWER-UNAVAILABLE':
				return this.angularFilterHelperService.translate('Call.Content.Call_Not_Answered');
			case 'NO_ANSWER-null':
				if (message.user.id !== this.sessionUser.user.id) {
					return this.angularFilterHelperService.translate('Call.Content.Missed_Call');
				} else {
					return this.angularFilterHelperService.translate('Call.Content.Call_Not_Answered');
				}
		}
	}
	
	pollNewPosts() {
		if (this.session.isLoggedIn()) {
			if (!this.pollLastModifiedAt) {
				this.pollLastModifiedAt = new Date(this.lastModifiedAt).getTime();
			}
			var pollParams: any = { lastModified: this.pollLastModifiedAt };
			if (this.firstPollCall) {
				this.firstPollCall = false;
				pollParams.initialCall = true;
			}
			this.pollLastModifiedAt = new Date(this.lastModifiedAt).getTime();
			this.chatRestServices.poll(pollParams,
				(chatUpdates) => {
					if (chatUpdates.posts) {
						this.handleNewMessages(chatUpdates.posts);
					}
					if (chatUpdates.events) {
						this.handleNewChatEvents(chatUpdates.events);
					}
				},
				(error) => {
					console.error('ChatService.PollNewPosts', error);
				}
			);
		} else {
			this.time.deleteTimer('CHAT_POST_POLLING_TIMER');
		}
	}
	
	handleNewMessages(newMessages) {
		if (newMessages.length > 0) {
			this.unreadMessages = this.mapMessagesByConversationId(newMessages);
			this.handleUnreadMessages(this.unreadMessages);
			this.angularHelperService.forEach(this.unreadMessages, (messages, chatId) => {
				if (this.chats[chatId] !== undefined) {
					this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.NEW_MESSAGE, messages, chatId);
				} else {
					this.chatRestServices.getChatById({ id: chatId },
						(chat) => {
							chat.lastPost = messages[0];
							this.profileRestServices.getContact({ id: chat.privateChatFriend.id },
								(user) => {
									chat.privateChatFriend = user;
									if (!chat.privateChatFriend.fullName && user.firstname && user.lastname) {
										chat.privateChatFriend.fullName = user.firstname + ' ' + user.lastname;
									}
									this.chats[chat.id] = chat;
									this.angularBroadcastHelperService.rootEmit(this.config.getBroadcastConfig().Chat.NEW, chat);
								},
								(error) => {
									console.error('ChatService.HandleNewMessages.GetContact', error);
								}
							);
						},
						(error) => {
							console.error('ChatService.HandleNewMessages.GetChatById', error);
						}
					);
				}
			});
		}
	}
	
	handleNewChatEvents(newChatEvents) {
		if (newChatEvents.length > 0) {
			var lastModifiedEvent: any = newChatEvents.reduce((prev, next) => {
				if (!prev) return next;
				if (!next) return prev;
				var prevModified: any = new Date(prev.modified || 0);
				var nextModified: any = new Date(next.modified || 0);
				return prevModified > nextModified ? prev : next;
			});
			if (lastModifiedEvent && lastModifiedEvent.modified) {
				var modified: any = new Date(lastModifiedEvent.modified);
				this.lastModifiedAt = Math.max(modified.getTime(), this.lastModifiedAt);
			}
			var groupedChatEvents: any = this.mapChatEventsByConversationId(newChatEvents);
			this.angularHelperService.forEach(groupedChatEvents, (events, chatId) => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.NEW_EVENT, events, chatId);
			});
		}
	}
	
	updateLastSeenPost(updatedChatList) {
		this.angularHelperService.forEach(updatedChatList, (chat) => {
			if (!chat.modified) return;
			var modified: any = new Date(chat.modified);
			this.lastModifiedAt = Math.max(modified.getTime(), this.lastModifiedAt);
		});
	}
	
	handleUnreadMessages(checkedMessages) {
		this.angularHelperService.forEach(checkedMessages, (messages, chatId) => {
			this.angularHelperService.forEach(this.chats, (chat, index) => {
				if (parseInt(chatId) === chat.id) {
					this.setChatLastMessage(chatId, messages[messages.length - 1]);
					var isPreVisitChat = this.angularRoutingHelperService.getCurrentPath() === 'pre-visit-chat/:id';
					if (!isPreVisitChat) {
						this.notifyUnreadMessages(this.chats[chatId], messages);
					}
				}
			});
		});
	}
	
	notifyUnreadMessages(chat, messages) {
		if (!chat || !messages || !messages.length) return;
		if (chat.lastPost.id === chat.lastSeenPostId || chat.lastNotifiedPost === chat.lastPost.id) return;
		
		var user: any = this.session.getSession().user;
		var msgs: any = messages.filter((message) => {
			return message.id > (chat.lastSeenPostId || 0) && message.user.id !== user.id;
		});
		
		if (!msgs || !msgs.length) return;
		var lastUnreadMessage: any = msgs.slice().pop();
		if (moment(lastUnreadMessage.created).isBefore(moment(this.initDate))) return;
		
		var name: any = chat.privateChatFriend.fullName || (chat.privateChatFriend.firstname + ' ' + chat.privateChatFriend.lastname);
		var title: any = this.angularFilterHelperService.translate('Chats.Notifications.New_Message').replace('%s', name);
		var body;
		if (msgs.length > 1) {
			body = this.angularFilterHelperService.translate('Chats.Notifications.New_Messages').replace('%s', msgs.length);
		} else {
			var msg: any = msgs[0];
			switch (msg.postType) {
				case 'CALL':
					body = this.getCallingMessage(msg) + ' (' + (msg.duration || 0)
						+ this.angularFilterHelperService.translate('Chats.Other.Seconds') + ')';
					break;
				case 'PICTURE':
					body = msg.originalFileName;
					break;
				case 'AUDIO':
					body = this.angularFilterHelperService.translate('Sidebar.Content.Audio_Messages');
					break;
				default:
					body = msg.content;
			}
		}
		
		var opts: any = {
			type: 'chat',
			lastId: chat.lastPost.id,
			title: title,
			body: body,
			img: chat.privateChatFriend.fileUrl,
			onClick: () => { this.angularRoutingHelperService.setPath(['chats/', chat.id]); },
		};
		this.notificationService.displayPushNotification(opts);
		chat.lastNotifiedPost = chat.lastPost.id;
	}
	
	setChatLastMessage(chatId, message) {
		this.chats[chatId].lastPost = message;
	}
	
	mapChatEventsByConversationId(events) {
		var chatEventsMappedByConversation: any = {};
		
		this.angularHelperService.forEach(events, (chatEvent, index) => {
			if (chatEventsMappedByConversation[chatEvent.chat.id] && chatEventsMappedByConversation[chatEvent.chat.id] instanceof Array) {
				chatEventsMappedByConversation[chatEvent.chat.id].push(chatEvent);
			} else {
				chatEventsMappedByConversation[chatEvent.chat.id] = [chatEvent];
			}
		});
		
		return chatEventsMappedByConversation;
	}
	
	mapMessagesByConversationId(messages) {
		var messagesMappedByConversation: any = {};
		
		this.angularHelperService.forEach(messages, (message, index) => {
			if (messagesMappedByConversation[message.chat.id] && messagesMappedByConversation[message.chat.id] instanceof Array) {
				messagesMappedByConversation[message.chat.id].push(message);
			} else {
				messagesMappedByConversation[message.chat.id] = [message];
			}
		});
		
		return messagesMappedByConversation;
	}
	
	mapChatFriendName(conversations) {
		this.angularHelperService.forEach(conversations, (conversation, index) => {
			conversations[index].privateChatFriend.fullName = conversation.privateChatFriend.firstname
				+ ' ' + conversation.privateChatFriend.lastname;
		});
		
		return conversations;
	}
	
	mapConversationsById(conversations) {
		var mappedConversations: any = {};
		
		this.angularHelperService.forEach(conversations, (conversation, index) => {
			mappedConversations[conversation.id] = conversation;
		});
		
		return mappedConversations;
	}
	
}
